import { SxProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import LogoSmall from './LogoSmall';

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 9998,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

type Props = {
  sx?: SxProps<Theme>;
};

export default function LoadingScreen({ ...other }: Props) {
  return (
    <RootStyle {...other}>
      <LogoSmall sx={{ width: 64, height: 64 }} />
    </RootStyle>
  );
}
